const actions = {
    /* ASSET TYPES */
    ASSET_TYPE_SET: 'ASSET_TYPE_SET',
    ASSET_TYPE_SET_DEPRECIATE_MODE: 'ASSET_TYPE_SET_DEPRECIATE_MODE',
    ASSET_TYPE_CREATE_REQUEST: 'ASSET_TYPE_CREATE_REQUEST',
    ASSET_TYPE_CREATE_SUCCESS: 'ASSET_TYPE_CREATE_SUCCESS',
    ASSET_TYPE_CREATE_FAIL: 'ASSET_TYPE_CREATE_FAIL',
    ASSET_TYPE_READ_LIST_REQUEST: 'ASSET_TYPE_READ_LIST_REQUEST',
    ASSET_TYPE_READ_LIST_SUCCESS: 'ASSET_TYPE_READ_LIST_SUCCESS',
    ASSET_TYPE_READ_LIST_FAIL: 'ASSET_TYPE_READ_LIST_FAIL',
    ASSET_TYPE_READ_REQUEST: 'ASSET_TYPE_READ_REQUEST',
    ASSET_TYPE_READ_SUCCESS: 'ASSET_TYPE_READ_SUCCESS',
    ASSET_TYPE_READ_FAIL: 'ASSET_TYPE_READ_FAIL',
    ASSET_TYPE_UPDATE_REQUEST: 'ASSET_TYPE_UPDATE_REQUEST',
    ASSET_TYPE_UPDATE_SUCCESS: 'ASSET_TYPE_UPDATE_SUCCESS',
    ASSET_TYPE_UPDATE_FAIL: 'ASSET_TYPE_UPDATE_FAIL',
    ASSET_TYPE_DELETE_REQUEST: 'ASSET_TYPE_DELETE_REQUEST',
    ASSET_TYPE_DELETE_SUCCESS: 'ASSET_TYPE_DELETE_SUCCESS',
    ASSET_TYPE_DELETE_FAIL: 'ASSET_TYPE_DELETE_FAIL',
    /* ASSET DEPRECIATIONS */
    ASSET_DEPRECIATION_READ_DATE_LIST_REQUEST: 'ASSET_DEPRECIATION_READ_DATE_LIST_REQUEST',
    ASSET_DEPRECIATION_READ_DATE_LIST_SUCCESS: 'ASSET_DEPRECIATION_READ_DATE_LIST_SUCCESS',
    ASSET_DEPRECIATION_READ_DATE_LIST_FAIL: 'ASSET_DEPRECIATION_READ_DATE_LIST_FAIL',
    ASSET_DEPRECIATION_PREVIEW_REQUEST: 'ASSET_DEPRECIATION_PREVIEW_REQUEST',
    ASSET_DEPRECIATION_PREVIEW_SUCCESS: 'ASSET_DEPRECIATION_PREVIEW_SUCCESS',
    ASSET_DEPRECIATION_PREVIEW_FAIL: 'ASSET_DEPRECIATION_PREVIEW_FAIL',
    ASSET_DEPRECIATION_CREATE_REQUEST: 'ASSET_DEPRECIATION_CREATE_REQUEST',
    ASSET_DEPRECIATION_CREATE_SUCCESS: 'ASSET_DEPRECIATION_CREATE_SUCCESS',
    ASSET_DEPRECIATION_CREATE_FAIL: 'ASSET_DEPRECIATION_CREATE_FAIL',
    ASSET_DEPRECIATION_DELETE_LIST_REQUEST: 'ASSET_DEPRECIATION_DELETE_LIST_REQUEST',
    ASSET_DEPRECIATION_DELETE_LIST_SUCCESS: 'ASSET_DEPRECIATION_DELETE_LIST_SUCCESS',
    ASSET_DEPRECIATION_DELETE_LIST_FAIL: 'ASSET_DEPRECIATION_DELETE_LIST_FAIL',
    /* ASSETS */
    ASSET_READ_PURCHASE_LIST_REQUEST: 'ASSET_READ_PURCHASE_LIST_REQUEST',
    ASSET_READ_PURCHASE_LIST_SUCCESS: 'ASSET_READ_PURCHASE_LIST_SUCCESS',
    ASSET_READ_PURCHASE_LIST_FAIL: 'ASSET_READ_PURCHASE_LIST_FAIL',
    ASSET_SET: 'ASSET_SET',
    ASSET_SET_DEPRECIATE_MODE: 'ASSET_SET_DEPRECIATE_MODE',
    ASSET_SET_PURCHASE_DATE: 'ASSET_SET_PURCHASE_DATE',
    ASSET_SET_DEPRECIATION_START_DATE: 'ASSET_SET_DEPRECIATION_START_DATE',
    ASSET_SET_IS_DEPRECIATED: 'ASSET_SET_IS_DEPRECIATED',
    ASSET_CREATE_REQUEST: 'ASSET_CREATE_REQUEST',
    ASSET_CREATE_SUCCESS: 'ASSET_CREATE_SUCCESS',
    ASSET_CREATE_FAIL: 'ASSET_CREATE_FAIL',
    ASSET_BULK_CREATE_REQUEST: 'ASSET_BULK_CREATE_REQUEST',
    ASSET_BULK_CREATE_SUCCESS: 'ASSET_BULK_CREATE_SUCCESS',
    ASSET_BULK_CREATE_FAIL: 'ASSET_BULK_CREATE_FAIL',
    ASSET_READ_LIST_REQUEST: 'ASSET_READ_LIST_REQUEST',
    ASSET_READ_LIST_SUCCESS: 'ASSET_READ_LIST_SUCCESS',
    ASSET_READ_LIST_FAIL: 'ASSET_READ_LIST_FAIL',
    ASSET_READ_REQUEST: 'ASSET_READ_REQUEST',
    ASSET_READ_SUCCESS: 'ASSET_READ_SUCCESS',
    ASSET_READ_FAIL: 'ASSET_READ_FAIL',
    ASSET_UPDATE_REQUEST: 'ASSET_UPDATE_REQUEST',
    ASSET_UPDATE_SUCCESS: 'ASSET_UPDATE_SUCCESS',
    ASSET_UPDATE_FAIL: 'ASSET_UPDATE_FAIL',
    ASSET_DELETE_REQUEST: 'ASSET_DELETE_REQUEST',
    ASSET_DELETE_SUCCESS: 'ASSET_DELETE_SUCCESS',
    ASSET_DELETE_FAIL: 'ASSET_DELETE_FAIL',
    ASSET_DISPOSAL_SET: 'ASSET_DISPOSAL_SET',
    ASSET_DISPOSAL_SET_AMOUNT: 'ASSET_DISPOSAL_SET_AMOUNT',
    ASSET_DISPOSAL_SET_LAST_DEPRECIATION_TYPE: 'ASSET_DISPOSAL_SET_LAST_DEPRECIATION_TYPE',
    ASSET_DISPOSAL_SET_LAST_DEPRECIATION_DATE: 'ASSET_DISPOSAL_SET_LAST_DEPRECIATION_DATE',
    ASSET_DISPOSE_REQUEST: 'ASSET_DISPOSE_REQUEST',
    ASSET_DISPOSE_SUCCESS: 'ASSET_DISPOSE_SUCCESS',
    ASSET_DISPOSE_FAIL: 'ASSET_DISPOSE_FAIL',
    ASSET_UNDISPOSE_REQUEST: 'ASSET_UNDISPOSE_REQUEST',
    ASSET_UNDISPOSE_SUCCESS: 'ASSET_UNDISPOSE_SUCCESS',
    ASSET_UNDISPOSE_FAIL: 'ASSET_UNDISPOSE_FAIL',
    /* OTHERS */
    ASSET_RESET_STATE: 'ASSET_RESET_STATE',
    /* Editable Table Related */
    ASSET_SET_EDIT_LINE: 'ASSET_SET_EDIT_LINE',
    ASSET_EDIT_PREV_LINE: 'ASSET_EDIT_PREV_LINE',
    ASSET_EDIT_NEXT_LINE: 'ASSET_EDIT_NEXT_LINE',
    ASSET_SET_FOCUSED_ELEMENT: 'ASSET_SET_FOCUSED_ELEMENT',
    ASSET_SET_ITEMS: 'ASSET_SET_ITEMS',
    ASSET_SET_ITEM: 'ASSET_SET_ITEM',
    ASSET_ADD_ITEM: 'ASSET_ADD_ITEM',
    ASSET_ADD_ITEMS: 'ASSET_ADD_ITEMS',
    ASSET_REMOVE_ITEM: 'ASSET_REMOVE_ITEM',

    /* ASSET TYPES */
    setAssetType: assetType => ({
        type: actions.ASSET_TYPE_SET,
        assetType,
    }),
    setAssetTypeDepreciateMode: depreciateMode => ({
        type: actions.ASSET_TYPE_SET_DEPRECIATE_MODE,
        depreciateMode,
    }),
    createAssetType: request => ({
        type: actions.ASSET_TYPE_CREATE_REQUEST,
        request,
    }),
    readAssetTypeList: request => ({
        type: actions.ASSET_TYPE_READ_LIST_REQUEST,
        request,
    }),
    readAssetType: id => ({
        type: actions.ASSET_TYPE_READ_REQUEST,
        id,
    }),
    updateAssetType: (id, request) => ({
        type: actions.ASSET_TYPE_UPDATE_REQUEST,
        id,
        request,
    }),
    deleteAssetType: id => ({
        type: actions.ASSET_TYPE_DELETE_REQUEST,
        id,
    }),
    /* ASSET DEPRECIATIONS */
    readAssetDepreciationDateList: () => ({
        type: actions.ASSET_DEPRECIATION_READ_DATE_LIST_REQUEST,
    }),
    previewAssetDepreciation: request => ({
        type: actions.ASSET_DEPRECIATION_PREVIEW_REQUEST,
        request,
    }),
    createAssetDepreciation: request => ({
        type: actions.ASSET_DEPRECIATION_CREATE_REQUEST,
        request,
    }),
    deleteAssetDepreciationList: request => ({
        type: actions.ASSET_DEPRECIATION_DELETE_LIST_REQUEST,
        request,
    }),
    /* ASSETS */
    readPurchaseList: () => ({
        type: actions.ASSET_READ_PURCHASE_LIST_REQUEST,
    }),
    setAsset: asset => ({
        type: actions.ASSET_SET,
        asset,
    }),
    setAssetDepreciateMode: depreciateMode => ({
        type: actions.ASSET_SET_DEPRECIATE_MODE,
        depreciateMode,
    }),
    setAssetPurchaseDate: purchaseDate => ({
        type: actions.ASSET_SET_PURCHASE_DATE,
        purchaseDate,
    }),
    setAssetDepreciationStartDate: depreciationStartDate => ({
        type: actions.ASSET_SET_DEPRECIATION_START_DATE,
        depreciationStartDate,
    }),
    setAssetIsDepreciated: isDepreciated => ({
        type: actions.ASSET_SET_IS_DEPRECIATED,
        isDepreciated,
    }),
    createAsset: request => ({
        type: actions.ASSET_CREATE_REQUEST,
        request,
    }),
    createBulkAsset: request => ({
        type: actions.ASSET_BULK_CREATE_REQUEST,
        request,
    }),
    readAssetList: request => ({
        type: actions.ASSET_READ_LIST_REQUEST,
        request,
    }),
    readAsset: id => ({
        type: actions.ASSET_READ_REQUEST,
        id,
    }),
    updateAsset: (id, request) => ({
        type: actions.ASSET_UPDATE_REQUEST,
        id,
        request,
    }),
    deleteAsset: id => ({
        type: actions.ASSET_DELETE_REQUEST,
        id,
    }),
    setDisposal: disposal => ({
        type: actions.ASSET_DISPOSAL_SET,
        disposal,
    }),
    setDisposalAmount: disposalAmount => ({
        type: actions.ASSET_DISPOSAL_SET_AMOUNT,
        disposalAmount,
    }),
    setDisposalLastDepreciationType: disposalLastDepreciationType => ({
        type: actions.ASSET_DISPOSAL_SET_LAST_DEPRECIATION_TYPE,
        disposalLastDepreciationType,
    }),
    setDisposalLastDepreciationDate: disposalLastDepreciationDate => ({
        type: actions.ASSET_DISPOSAL_SET_LAST_DEPRECIATION_DATE,
        disposalLastDepreciationDate,
    }),
    disposeAsset: (id, request) => ({
        type: actions.ASSET_DISPOSE_REQUEST,
        id,
        request,
    }),
    undisposeAsset: (id, request = {}) => ({
        type: actions.ASSET_UNDISPOSE_REQUEST,
        id,
        request,
    }),

    /* OTHERS */
    resetState: () => ({
        type: actions.ASSET_RESET_STATE,
    }),

    /* Editable Table Related */
    setEditLine: line => ({
        type: actions.ASSET_SET_EDIT_LINE,
        line,
    }),
    editPrevLine: () => ({
        type: actions.ASSET_EDIT_PREV_LINE,
    }),
    editNextLine: () => ({
        type: actions.ASSET_EDIT_NEXT_LINE,
    }),
    setFocusedElement: element => ({
        type: actions.ASSET_SET_FOCUSED_ELEMENT,
        element,
    }),
    setItems: items => ({
        type: actions.ASSET_SET_ITEMS,
        items,
    }),
    setItem: item => ({
        type: actions.ASSET_SET_ITEM,
        item,
    }),
    addItem: (item, editItem = false) => ({
        type: actions.ASSET_ADD_ITEM,
        item,
        editItem,
    }),
    addItems: items => ({
        type: actions.ASSET_ADD_ITEMS,
        items,
    }),
    removeItem: line => ({
        type: actions.ASSET_REMOVE_ITEM,
        line,
    }),
};
export default actions;
